$(document).ready(function() {
	$("#datepicker").datepicker({
		format: 'dd/mm/yyyy',
		autoclose: true,
		todayHighlight: true,
		// language: 'he-HE',
		orientation: "bottom",
	});
});

$(document).ready(function() {
    const items = $('.js_filter_items > div');
	console.log('4.1')
	function resetFilters() {
		$('#txt_lecturer').val('');
		$('#txt_segment').val('');
		$('#txt_language').val('');
		$('#txt_location').val('');
		$('#datepicker').val('');
		filterItems(); 
	}
    function populateFilters() {
        const filterOptions = {
            txt_lecturer: new Set(),
            txt_segment: new Set(),
            txt_language: new Set(),
            txt_location: new Set()
        };
        items.each(function() {
            filterOptions.txt_lecturer.add($(this).data('filter-txt-lecturer'));
            filterOptions.txt_segment.add($(this).data('filter-txt-segment'));

            const languages = $(this).data('filter-txt-language')
                .split(/(?:,\s*with\s+translation\s+into\s+|\s*,\s*|\s*\/\s*)/)
                .map(language => language.trim());
            languages.forEach(language => filterOptions.txt_language.add(language));
            filterOptions.txt_location.add($(this).data('filter-txt-location'));
        });
        // populateSelect($('#txt_lecturer'), filterOptions.txt_lecturer,'All - Lecturers');
        populateSelect($('#txt_segment'), filterOptions.txt_segment,'Segments - All');
        populateSelect($('#txt_language'), filterOptions.txt_language,'Languages - All');
        populateSelect($('#txt_location'), filterOptions.txt_location,'Locations - All');
    }

    function populateSelect(selectElement, optionsSet, all_title) {
        selectElement.html('');
        selectElement.append(`<option value="">`+all_title+`</option>`);
        optionsSet.forEach(option => {
            if (option.trim() !== '') {
                selectElement.append(`<option value="${option}">${option}</option>`);
            }
        });
    }
    function filterItems() {
		console.log('filterItems')
        const selectedtxt_lecturer = $('#txt_lecturer').val().trim();
        const selectedtxt_segment = $('#txt_segment').val();
        const selectedtxt_language = $('#txt_language').val();
        const selectedtxt_location = $('#txt_location').val();
		const selectedDate = $('#datepicker').datepicker('getDate');
		const selectedDate_html_val = $('#datepicker').val();
		console.log(selectedDate)
		console.log(selectedDate)

        items.each(function() {
            const itemtxt_lecturer = $(this).data('filter-txt-lecturer');
            const itemtxt_segment = $(this).data('filter-txt-segment');
            const itemLanguages = $(this).data('filter-txt-language')
			.split(/(?:,\s*with\s+translation\s+into\s+|\s*,\s*|\s*\/\s*)/)
			.map(language => language.trim());
			const itemDateStart = new Date($(this).data('filter-date-start'));
			const itemDateEnd = new Date($(this).data('filter-date-end'));
            const itemtxt_location = $(this).data('filter-txt-location');
            if ((selectedtxt_lecturer === '' || itemtxt_lecturer === selectedtxt_lecturer || itemtxt_lecturer.includes(selectedtxt_lecturer) || itemtxt_lecturer.toLowerCase().includes(selectedtxt_lecturer.toLowerCase()) ||  selectedtxt_lecturer === 'Select All') &&
                (selectedtxt_segment === '' || itemtxt_segment === selectedtxt_segment) &&
                (selectedtxt_language === '' || itemLanguages.includes(selectedtxt_language)) &&
                (selectedtxt_location === '' || itemtxt_location === selectedtxt_location) &&
                (  selectedDate_html_val =='' || (selectedDate >= itemDateStart && selectedDate <= itemDateEnd)     )) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }
	$('#resetFilters').on('click', resetFilters);
    $('#txt_lecturer').on('input', filterItems);
    populateFilters();
    $('#txt_segment, #txt_language, #txt_location, #datepicker').on('change', filterItems);
});
